module.exports = __webpack_public_path__ + "static/media/tea_kokiri_logo_white.b2e028da.png";